import Breadcrumbs from 'Components/Breadcrumbs'
import CustomButton from 'Components/CustomButton'
import ListActions from 'Components/ListActions'
import PageTitle from 'Components/PageTitle'
import TicketSaleTargetDrawer from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetDrawer'
import TicketSaleTargetList from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetList'
import useTicketSaleTargetsWithParams from 'Services/SalesManagement/Features/TicketSale/Hooks/useTicketSaleTargetsWithParams'
import useListPage from 'Services/SalesManagement/Hooks/useListPage'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function TicketSaleTargetListPage() {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/ticket-sale-targets`
  const title = t`Ticket sale targets`

  const {
    data,
    isFetching,
    params,
    setParams,
    selectedTicketSaleTargetId,
    setSelectedTicketSaleTargetId
  } = useTicketSaleTargetsWithParams()

  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    { title }
  ])
  const { isDrawerOpen, handleRowClick, handleDrawerClose, handleChangePage, handleRequestSort } =
    useListPage({
      selectedId: selectedTicketSaleTargetId,
      setSelectedId: setSelectedTicketSaleTargetId,
      params,
      setParams
    })

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs items={breadcrumbs} />
        <PageTitle>{title}</PageTitle>
      </Box>
      <ListActions>
        <CustomButton
          onClick={() => navigate(`${baseUrl}/create`)}
          size="small"
          startIcon={<AddIcon />}
        >
          {t`Create new ticket sale target`}
        </CustomButton>
      </ListActions>
      <TicketSaleTargetList
        rows={data?.results ?? []}
        isLoading={isFetching}
        params={params}
        handleRequestSort={handleRequestSort}
        handleChangePage={handleChangePage}
        count={data?.count ?? 0}
        page={params.page - 1}
        onRowClick={handleRowClick}
        selectedTicketSaleTargetId={selectedTicketSaleTargetId}
      />
      <TicketSaleTargetDrawer
        open={isDrawerOpen}
        handleClose={handleDrawerClose}
        selectedTicketSaleTargetId={selectedTicketSaleTargetId}
      />
    </Box>
  )
}
